import { ITC_UPSELL_MODAL_EXPERIMENT } from 'components/admin/utils/feature-flags';
import { useInfinityTestingBillingStatus } from 'components/billing/modules/plans/hooks/useInfinityTestingBillingStatus';
import { usePSLabs } from 'controllers/contexts/labsFeatures';

export type ITCUpsellVariant = 'control' | 'treatment';

export type InfinityBillingState =
  | 'has_product'
  | 'trial_ongoing'
  | 'trial_available'
  | 'contact_sales'
  | 'none';

export interface ITCUpsellExperimentState {
  variant: ITCUpsellVariant;
  eligible: boolean;
  infinityBillingState: InfinityBillingState;
}

const deriveBillingState = ({
  hasProduct,
  trialOngoing,
  isEligible,
  trialAvailable,
}: {
  hasProduct: boolean;
  trialOngoing: boolean;
  isEligible: boolean;
  trialAvailable: boolean;
}): InfinityBillingState => {
  if (hasProduct) return 'has_product';
  if (trialOngoing) return 'trial_ongoing';
  if (isEligible && trialAvailable) return 'trial_available';
  if (isEligible) return 'contact_sales';
  return 'none';
};

export const useITCUpsellExperiment = (): ITCUpsellExperimentState => {
  const { hasLabsFlag } = usePSLabs();
  const { hasProduct, trialOngoing, isEligible, trialAvailable } =
    useInfinityTestingBillingStatus();

  const flagOn = hasLabsFlag(ITC_UPSELL_MODAL_EXPERIMENT);
  const eligible = isEligible && hasProduct;
  const variant: ITCUpsellVariant =
    flagOn && eligible ? 'treatment' : 'control';

  return {
    variant,
    eligible,
    infinityBillingState: deriveBillingState({
      hasProduct,
      trialOngoing,
      isEligible,
      trialAvailable,
    }),
  };
};
